<script setup lang="ts">
type Props = {
  label?: string
}

defineProps<Props>()
</script>

<template>
  <div
    class="bg-neutral-light-6 sticky top-0 h-8 truncate overflow-hidden rounded-md p-2 text-sm whitespace-nowrap"
  >
    <slot>
      No players assigned to
      <span class="font-bold">{{ label || 'section' }}</span>
    </slot>
  </div>
</template>
